import React, { Component } from 'react'
import Measure from 'react-measure'

import {checkUserMediaContrainsCompatibility} from '../utils/browserUtils';

require(`../assets/${process.env.PAGE}/css/components/camera.css`);

import { resizeImage } from '../utils/utils';

const CAPTURE_OPTIONS = {
    audio: false,
    video: { facingMode: "environment",
      width: { ideal: 20000 },
      height: { ideal: 20000 }
    }
};

const FIXED_CAPTURE_OPTIONS = {
  audio: false,
  video: {
    facingMode: "environment",
    width: 1200,
    height: 746,
  }
};

class DocumentCamera extends Component {
  constructor(props){
    super(props);
    this.state = {
        stream: null,
        picture: null,
        pictureUrl: null,
        saved: false,
        playing: false,
        hasCameraPermission: false,
        parentSize: {
          height:0,
          width:0,
        },
        mediaSize:{
          height:0,
          width:0,
          aspectRatio: 1.586,
        },
        imageToCapture:{
          height:0,
          width:0,
        },
        resizedVideo: {
          height: null,
          width: null,
          contentComponent: null,
          videoAspectRatio: null,
          videoWidth: null,
          videoHeight: null
        }
    }
    this.video = null;
    this.containerVideo = null;
    this.canvas = null;
    this.imageToCapture = null;
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleCanPlay = this.handleCanPlay.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleShapeResize = this.handleShapeResize.bind(this);
    this.onCapture = this.onCapture.bind(this);
    this.handleCapture = this.handleCapture.bind(this);
    this.onClear = this.onClear.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  componentDidMount(){
    let captureOptions = this.props.captureOptions || CAPTURE_OPTIONS;

    if(!checkUserMediaContrainsCompatibility()){
      captureOptions = FIXED_CAPTURE_OPTIONS;
    }

    navigator.mediaDevices
    .getUserMedia(captureOptions)
    .then(stream => {
        this.setState({
          ...this.state,
          stream: stream,
          hasCameraPermission: true,
        })
    });
  }

  componentWillUnmount(){
    this.state.stream.getTracks().forEach(track => {
        track.stop();
    });
  }

  handleOnChange(event){
    event.preventDefault()
    if(this.props.onChange){
      this.props.onChange(this.state.picture);
    }
    this.setState({
      ...this.state,
      saved: true
    })
  }

  handleCapture(event) {
    const { mediaSize, parentSize, resizedVideo } = this.state;
    //const offset = this.calculateOffset(mediaSize, this.video);
    //console.log(imageToCapture);
    const shapeToCapture = {
      height: (parentSize.height > parentSize.width) ? parentSize.width * 0.9 * 0.62 : parentSize.height * 0.5,
      width: (parentSize.height > parentSize.width) ? parentSize.width * 0.9 : parentSize.height * 0.5 / 0.62,
    }
    const videoScale = resizedVideo.width / this.video.videoWidth
    /*const offset = this.calculateOffset({
      height: imageToCapture.height * 1.1,
      width: imageToCapture.width  * 1.1,
    },
    this.video);

    const parentOffset = this.calculateOffset({
      height: parentSize.height,
      width: parentSize.width,
    },
    this.video);

    const canvasOffset = this.calculateOffset({
      height: imageToCapture.height * 1.1,
      width: imageToCapture.width  * 1.1,
    },
    {
      videoWidth: parentSize.width,
      videoHeight: parentSize.height,
    });*/

    const offset = this.calculateOffset({
      height: shapeToCapture.height * 1.1,
      width: shapeToCapture.width * 1.1,
    },
    {
      videoWidth: resizedVideo.width,
      videoHeight: resizedVideo.height,
    });

    const realOffset = {
      x: offset.x / videoScale,
      y: offset.y / videoScale,
    }

    const realShape = {
      width: this.video.videoWidth - (realOffset.x * 2),
      height: this.video.videoHeight - (realOffset.y * 2),
    }
    if(event){
      event.preventDefault()
    }

    const resizedImageToProcess = resizeImage(realShape.width, realShape.height, 1200, 1200);

    let hiddenCanvas = document.createElement('canvas');
    this.canvas = hiddenCanvas;
    hiddenCanvas.height = resizedImageToProcess.height;
    hiddenCanvas.width = resizedImageToProcess.width;
    let hiddenContext = hiddenCanvas.getContext('2d');
    hiddenContext.drawImage(this.video,
                            realOffset.x,
                            realOffset.y,
                            realShape.width,
                            realShape.height,
                            0,
                            0,
                            resizedImageToProcess.width,
                            resizedImageToProcess.height);

    hiddenCanvas.toBlob(blob => this.onCapture(blob), "image/jpeg", 1);
    this.setState({
      ...this.state,
      pictureUrl: hiddenCanvas.toDataURL('image/jpeg',1),
    });
  }

  handleResize(contentRect){
    const { mediaSize, stream } = this.state;

    let calculatedSize = {};
    let parentSize = {};
    let resizedVideo = {};

    if(contentRect.entry){

      calculatedSize = {
        width: contentRect.entry.width,
        height: contentRect.entry.height
      }
      if (contentRect.entry.width > contentRect.entry.height){
        calculatedSize.height = Math.round(contentRect.entry.width / mediaSize.aspectRatio);
      } else {
        calculatedSize.width = Math.round(contentRect.entry.height / mediaSize.aspectRatio);
      }

      parentSize = {
        width: contentRect.entry.width,
        height: contentRect.entry.height,
      }

      if(this.video){
        let browserVideoSize = stream.getVideoTracks()[0].getSettings()
        let videoAspectRatio = null;
        let originalVideoSize = {
          width: browserVideoSize.width,
          height: browserVideoSize.height 
        }

        if(contentRect.entry.height > contentRect.entry.width){
          originalVideoSize = {
            width: (browserVideoSize.width > browserVideoSize.height) ? browserVideoSize.height : browserVideoSize.width,
            height: (browserVideoSize.width > browserVideoSize.height) ? browserVideoSize.width : browserVideoSize.height,
          }
        }


        videoAspectRatio = originalVideoSize.width / originalVideoSize.height ;

        const capturedScreenHeight = originalVideoSize.height * 100 / contentRect.entry.height;
        const capturdScreenWidth = originalVideoSize.width * 100 / contentRect.entry.width;
        if( capturedScreenHeight > capturdScreenWidth){
          resizedVideo = {
            width: contentRect.entry.width,
            height: contentRect.entry.width / videoAspectRatio,
          }
        }else {
          resizedVideo = {
            width: contentRect.entry.height * videoAspectRatio,
            height: contentRect.entry.height,
          }
        }

        resizedVideo = {
          ...resizedVideo,
          contentComponent: contentRect.entry,
          videoAspectRatio: videoAspectRatio,
          videoWidth: originalVideoSize.width,
          videoHeight: originalVideoSize.height
        }

      }


      this.setState({
        ...this.state,
        mediaSize:{
          ...calculatedSize,
          aspectRatio: mediaSize.aspectRatio
        },
        parentSize:{
          ...parentSize
        },
        resizedVideo:{
          ...resizedVideo
        }
      })
    }
  }

  handleShapeResize(contentRect){

    const { mediaSize } = this.state;

    let imageToCapture = {};

    if(contentRect.entry){

      imageToCapture = {
        width: contentRect.entry.width,
        height: contentRect.entry.height
      }

      this.setState({
        ...this.state,
        imageToCapture:{
          ...imageToCapture
        }
      })
    }
  }

  onCapture(blob) {

    this.setState({
      ...this.state,
      picture: blob
    });

  }

  handleClear() {
    const context = this.canvas.getContext("2d");
    context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.onClear();
  }

  onClear(blob) {
    this.setState({
      ...this.state,
      picture: null,
      pictureUrl: null
    });
  }


  handleCanPlay() {
    const { mediaSize } = this.state
    const newAspectRatio = this.calculateRatio(this.video.videoHeight, this.video.videoWidth);

    this.setState({
      ...this.state,
      playing: true,
      mediaSize:{
        ...mediaSize,
        aspectRatio: (newAspectRatio || mediaSize.aspectRatio)
      }
    })
    this.video.play();
  }

  calculateRatio(height, width){
    if (height && width) {
      const isLandscape = height <= width;
      const ratio = isLandscape ? width / height : height / width;
      return ratio;
    }
  }

  calculateDocumentFrame(containerWidth, containerHeight, frameAspectRatio, defaultFixedSide=null){
    let fixedSide = (containerWidth >= containerHeight) ? containerWidth : containerHeight;
    if(defaultFixedSide){
      fixedSide = (defaultFixedSide === 'width') ? containerWidth : containerHeight
    }
    const variableSide = (fixedSide == containerWidth) ? containerHeight : containerWidth;
    const fixedSideFrame = 20;
    const fixedContentSize = Math.round(fixedSide - (fixedSideFrame * 2));
    const variableContentSize = Math.round(fixedContentSize / frameAspectRatio);
    const variableSideFrame = ((variableSide - variableContentSize) / 2);
    return {
      frameWidth: (fixedSide === containerWidth) ? fixedSideFrame : variableSideFrame,
      frameHeight:(fixedSide === containerHeight) ? fixedSideFrame : variableSideFrame,
    }
  }

  calculateOffset(videoContainer, video){
    if (video && videoContainer){
        return {
            x: video.videoWidth > videoContainer.width ?  Math.round((video.videoWidth - videoContainer.width) / 2) : 0,
            y: video.videoHeight > videoContainer.height ?  Math.round((video.videoHeight - videoContainer.height) / 2) : 0,
        }
    }
  }

  render() {
    const { mediaSize, hasCameraPermission, imageToCapture, parentSize, resizedVideo, stream } = this.state;
    const { shapeStyle } = this.props;
    let parentOffset = null;
    let canvasOffset = null;
    let shapeSize = {};
    let originalVideoSize = null ;

  if (this.state.stream && this.video) {
    parentOffset = this.calculateOffset({
      height: parentSize.height,
      width: parentSize.width,
    },
    this.video);
    canvasOffset = this.calculateOffset({
      height: imageToCapture.height * 1.1,
      width: imageToCapture.width  * 1.1,
    },
    {
      videoWidth: parentSize.width,
      videoHeight: parentSize.height,
    });
    originalVideoSize = stream.getVideoTracks()[0].getSettings()
  }

    if (this.state.stream && this.video && !this.video.srcObject) {
        this.video.srcObject = this.state.stream;
    }


    const documentFrames = this.calculateDocumentFrame(mediaSize.width, mediaSize.height, shapeStyle.aspectRatio, shapeStyle.defaultFixedSide);
    const videoOffset = this.calculateOffset(mediaSize, this.video);

    const ConfirmButtons = (<div>
                              <button className='btn btn-primary action-button' onClick={this.handleOnChange}><span className="glyphicon glyphicon-ok" aria-hidden="true"></span></button>
                              <button className='btn btn-primary action-button' onClick={this.handleClear}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
                            </div>);
    const shownButtons = this.state.picture ? ConfirmButtons :  (<button onClick={this.handleCapture} className='btn btn-primary btn-lg action-button'>
                                                                    <span className="glyphicon glyphicon-camera" aria-hidden="true">
                                                                    </span>
                                                                </button>);
    const alert = (
      <div class="alert alert-warning" role="alert">
        <span>
          Debes aceptar el permiso para poder acceder a tu camara.
        </span>
      </div>
    );


    return (
      <div
      style={{
        height: "100%",
        width: "100%",
        background: "#000",
      }}>
        <div style={{
          height: "100%",
          width: "100%",
          margin: "0 auto",
        }}>
            { (!hasCameraPermission && alert) || 
              (<Measure onResize={this.handleResize}>
                {({ measureRef }) => (
                  <div 
                  ref={measureRef}
                  style={{
                    position:"relative",
                    height: "100%",
                    width: "100%",
                    overflow:"hidden"
                  }}>
                    <video 
                      ref={(component) => { this.video = component }}
                      onPlay={this.handleCanPlay}
                      style={{
                        position: 'absolute',
                        width: (resizedVideo && resizedVideo.width || "100%"),
                        height:(resizedVideo && resizedVideo.height || "100%"),
                        objectFit: "fill",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                      }}
                      hidden={this.state.picture}
                      autoPlay
                      playsInline
                      muted
                    />
                    <div
                      style={{
                        position: 'absolute',
                        width: "100%", 
                        height: "100%",
                      }}>
                        <Measure onResize={this.handleShapeResize}>
                          {({ measureRef }) => (<div 
                            style={{
                              position: "absolute",
                              marginLeft: "50%",
                              transform: "translate(-50%, -50%)",
                              top: "50%",
                              height: (parentSize.height > parentSize.width) ? parentSize.width * 0.9 * 0.62 : parentSize.height * 0.5,
                              width: (parentSize.height > parentSize.width) ? parentSize.width * 0.9 : parentSize.height * 0.5 / 0.62,
                              boxShadow: '0px 0px 20px 500px rgba(0, 0, 0, 0.6)',
                              border: '1px solid #ffffff',
                              borderRadius: "15%",
                              ...shapeStyle,
                            }}
                            ref={measureRef}
                            hidden={this.state.picture}
                            id={'prueba'}>
                          </div>)}
                        </Measure>
                        <img 
                          src={this.state.pictureUrl}
                          style={{
                            position: "absolute",
                            marginLeft: "50%",
                            transform: "translate(-50%, -50%)",
                            top: "50%",
                            height: (parentSize.height > parentSize.width) ? parentSize.width * 0.9 * 0.62 : parentSize.height * 0.5,
                            width: (parentSize.height > parentSize.width) ? parentSize.width * 0.9 : parentSize.height * 0.5 / 0.62,
                          }}
                          hidden={!this.state.pictureUrl}/>
                        <div
                          style={{
                            position: "absolute",
                            marginLeft: "50%",
                            transform: "translateX(-50%)",
                            top: "5%",
                            textAlign:"center",
                          }}>
                          <img 
                            src={this.props.headerIcon}
                            style={{
                              maxHeight: "48px",
                              width: "100%"
                          }}/>
                          <span>
                            <p><h3>{this.props.headerTitle}</h3></p>
                          </span>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            marginLeft: "50%",
                            transform: "translateX(-50%)",
                            bottom: "3%",
                            textAlign:"center",
                          }}>
                          {(this.state.updateCamera && (<h3>Camara actualizada</h3>))}
                          <span>
                            <p><h3>Chequeá que se lean bien los datos de tu DNI</h3></p>
                          </span>
                          {(!this.state.saved && shownButtons)}
                        </div>
                    </div>
                  </div>
              )
            }
            </Measure>)
            }
        </div>
      </div>
    );
  }
}
module.exports = DocumentCamera


/** WEBPACK FOOTER **
 ** ./src/components/DocumentCamera.js
 **/